import { motion } from "framer-motion";
import OptimizedImage from "./OptimizedImage";

interface PageBannerProps {
  title: string;
  description: string;
  backgroundImage?: string;
  backgroundPosition?: string;
  priority?: boolean;
}

export default function PageBanner({ 
  title, 
  description, 
  backgroundImage = '/assets/PDM07398.webp',
  backgroundPosition = '50%'
  , priority = false
}: PageBannerProps) {
  return (
    <div className="relative py-24 bg-gray-900 overflow-hidden">
      {/* Priority load the banner image */}
      <div className="absolute inset-0 opacity-40">
        <OptimizedImage 
          src={backgroundImage}
          alt={title}
          className="w-full h-full"
          objectFit="cover"
          priority={priority}
        />
      </div>
      <div className="relative max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 text-center z-10">
        <motion.h1
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          className="text-4xl font-bold text-white mb-6 font-heading"
        >
          {title}
        </motion.h1>
        <motion.p
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ delay: 0.2 }}
          className="text-2xl text-white max-w-2xl mx-auto"
        >
          {description}
        </motion.p>
      </div>
    </div>
  );
}
